module.exports = __webpack_public_path__ + "img/avatar4.a26137ff.png";